import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "../lib/api";

export default function AlertsBell() {
  const navigate = useNavigate();
  const [summary, setSummary] = useState({ alert_total: 0, alert_high: 0, overdue_tasks: 0, open_tasks: 0 });

  useEffect(() => {
    let cancelled = false;
    const fetchOnce = async () => {
      try {
        const { data } = await api.get(`/operations/alerts/summary`);
        if (!cancelled) setSummary(data);
      } catch { /* silent — auth might be transitioning */ }
    };
    fetchOnce();
    const id = setInterval(fetchOnce, 60000);  // refresh every 60s
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  const count = (summary.alert_total || 0) + (summary.overdue_tasks || 0);
  const hot = (summary.alert_high || 0) + (summary.overdue_tasks || 0);

  return (
    <button
      onClick={() => navigate("/admin/alerts")}
      data-testid="topbar-alerts-bell"
      className="relative w-9 h-9 rounded-md hover:bg-[#F9FAFB] flex items-center justify-center text-[#6B7280] hover:text-[#0A2540] transition-colors"
      title={`${summary.alert_total} alerts · ${summary.overdue_tasks} overdue tasks`}
    >
      <Bell className="w-4 h-4" />
      {count > 0 && (
        <span
          className={`absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold flex items-center justify-center tabular-nums ${hot > 0 ? "bg-[#B91C1C] text-white" : "bg-[#0066FF] text-white"}`}
          data-testid="topbar-alerts-count"
        >
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
}
